import { render } from "./money_from_l_history.vue?vue&type=template&id=0bbca646&scoped=true"
import script from "./money_from_l_history.vue?vue&type=script&lang=js"
export * from "./money_from_l_history.vue?vue&type=script&lang=js"

import "./money_from_l_history.vue?vue&type=style&index=0&id=0bbca646&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbca646"]])

export default __exports__